// File upload and download service

const API_BASE = process.env.NODE_ENV === 'production' 
  ? 'https://apps.acom.edu.au/api'
  : 'http://localhost:5000/api';

// Upload files for a request
export const uploadFiles = async (requestId, files, uploadedBy) => {
  const formData = new FormData();
  
  // Add files to form data
  files.forEach(file => {
    formData.append('files', file);
  });
  
  // Add uploader info
  formData.append('uploadedBy', uploadedBy);
  
  try {
    const response = await fetch(`${API_BASE}/uploads/${requestId}`, {
      method: 'POST',
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload files');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error uploading files:', error);
    throw error;
  }
};

// Get file info for a request
export const getFileInfo = async (requestId) => {
  try {
    const response = await fetch(`${API_BASE}/files/${requestId}`);
    
    if (!response.ok) {
      throw new Error('Failed to get file info');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error getting file info:', error);
    return [];
  }
};

// Download a file
export const downloadFile = (requestId, filename, originalName) => {
  const downloadUrl = `${API_BASE}/downloads/${requestId}/${filename}`;
  
  // Create a temporary anchor element and trigger download
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = originalName || filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Get download URL for a file
export const getDownloadUrl = (requestId, filename) => {
  return `${API_BASE}/downloads/${requestId}/${filename}`;
};